import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ClassIcon from "@mui/icons-material/Class";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import StyleIcon from "@mui/icons-material/Style";
import ContactsIcon from "@mui/icons-material/Contacts";
import SummarizeIcon from "@mui/icons-material/Summarize";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";

export const mockSidebarData = (userRole) => [
  {
    title: "Data",
    items: [
      {
        condition: userRole === "Admin",
        title: "Departments",
        to: "/departments",
        icon: <ApartmentIcon />,
      },
      {
        condition: userRole === "Admin",
        title: "Sections",
        to: "/sections",
        icon: <ClassIcon />,
      },
      {
        condition: userRole === "Admin",
        title: "Teachers",
        to: "/teachers",
        icon: <SupervisedUserCircleIcon />,
      },
      {
        condition: userRole === "Admin",
        title: "Students",
        to: "/students",
        icon: <PersonOutlineIcon />,
      },
      {
        condition: userRole === "Admin",
        title: "Admins",
        to: "/admins",
        icon: <PeopleOutlinedIcon />,
      },
      {
        condition: userRole === "Student",
        title: "Dictionary",
        to: "/dictionary",
        icon: <StyleIcon />,
      },
    ],
  },
  {
    title: "Pages",
    items: [
      {
        condition: userRole === "Admin",
        title: "Contacts",
        to: "/contacts",
        icon: <ContactsIcon />,
      },
      {
        condition: userRole === "Admin",
        title: "Complaints",
        to: "/complaints",
        icon: <SummarizeIcon />,
      },
      {
        condition: userRole === "Admin",
        title: "Calendar",
        to: "/calendar",
        icon: <CalendarTodayOutlinedIcon />,
      },
      {
        title: "FAQ Page",
        to: "/faq",
        icon: <HelpOutlineOutlinedIcon />,
      },
    ],
  },
  {
    title: "Charts",
    items: [
      {
        condition: userRole === "Admin",
        title: "Bar Chart",
        to: "/bar",
        icon: <BarChartOutlinedIcon />,
      },
      {
        condition: userRole === "Admin",
        title: "Pie Chart",
        to: "/pie",
        icon: <PieChartOutlineOutlinedIcon />,
      },
      {
        condition: userRole === "Admin",
        title: "Line Chart",
        to: "/line",
        icon: <TimelineOutlinedIcon />,
      },
      {
        condition: userRole === "Admin",
        title: "Geography Chart",
        to: "/geography",
        icon: <MapOutlinedIcon />,
      },
    ],
  },
];
